import { render, staticRenderFns } from "./ConvoInformation.vue?vue&type=template&id=4b1cd8d1&"
import script from "./ConvoInformation.vue?vue&type=script&lang=js&"
export * from "./ConvoInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports